import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import DEVICE_CONTEXT from "src/context/internal/device";
import { useTranslation } from "react-i18next";
import { EmptyState } from "src/components/base/empty-state";
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { AnchorCardList } from "src/components/device-acl-anchor-card";

/**
 * The properties for {@link DeviceInboundACL}
 */
export type DeviceInboundACLProps = {};

/**
 * The view to display the Inbound ACLs of a device
 */
function DeviceInboundACL(props: DeviceInboundACLProps) {
    const [t] = useTranslation("admin-device-view");
    const ctx = React.useContext(DEVICE_CONTEXT);
    const { tags, groups, subnets, device_groups } = ctx.device.inbound_rules;

    const isEmpty = tags.length === 0 && groups.length === 0 && subnets.length === 0 && device_groups.length === 0;

    if (isEmpty) {
        return (
            <EmptyState
                icon={<ShieldCheckIcon />}
                title={t("heading.no-inbound-rules")}
                description={t("description.no-inbound-rules")}
            />
        );
    }

    return (
        <div className={"flex flex-col gap-6"}>
            <AnchorCardList
                anchors={tags}
                prefix={"tag"}
                href={"/a/tags/$tagId/inbound-acls"}
                params={(anchor) => ({ tagId: anchor.uuid })}
                direction={"inbound"}
                aclAnchor={(anchor) => ({ type: "Tag", value: anchor })}
            />
            <AnchorCardList
                anchors={groups}
                prefix={"group"}
                href={"/a/groups/$groupId/inbound-acls"}
                params={(anchor) => ({ groupId: anchor.uuid })}
                direction={"inbound"}
                aclAnchor={(anchor) => ({ type: "Group", value: anchor })}
            />
            <AnchorCardList
                anchors={subnets}
                prefix={"subnet"}
                href={"/a/subnets/$subnetId/inbound-acls"}
                params={(anchor) => ({ subnetId: anchor.uuid })}
                direction={"inbound"}
                aclAnchor={(anchor) => ({ type: "Subnet", value: anchor })}
            />
            <AnchorCardList
                anchors={device_groups}
                prefix={"device-group"}
                href={"/a/devicegroups/$deviceGroupId/inbound-acls"}
                params={(anchor) => ({ deviceGroupId: anchor.uuid })}
                direction={"inbound"}
                aclAnchor={(anchor) => ({ type: "DeviceGroup", value: anchor })}
            />
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/devices/$deviceId/_device/inbound-acls")({
    component: DeviceInboundACL,
});
